module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-blog-layout"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "blog"
  }, [_c('section', [_c('div', {
    staticClass: "article-layout"
  }, [_c('blog-article', {
    attrs: {
      "title": _vm.title,
      "text": _vm.text,
      "middleThumb": _vm.middleThumb,
      "videos": _vm.videos,
      "view": _vm.view,
      "comments": _vm.comments,
      "event_type": _vm.event_type,
      "cop_multi_name": _vm.cop_multi_name
    }
  }, [(_vm.isReview) ? [_vm._t("default", null, {
    "slot": "articleReview"
  })] : _vm._e()], 2), _c('section', {
    staticClass: "article-buttons"
  }, [_c('div', {
    staticClass: "article-buttons-col"
  }, [_c('ext-button', {
    attrs: {
      "size": "small",
      "to": _vm.prevId,
      "wide": _vm.isPhoneOrTablet,
      "color": _vm.prevBtnColor,
      "fill": true,
      "factor": 1.3,
      "disabled": _vm.hasPrevDisabled
    }
  }, [_vm._v("Предыдущая запись")])], 1), _c('div', {
    staticClass: "article-buttons-col"
  }, [_c('ext-button', {
    attrs: {
      "color": "default",
      "size": "small",
      "to": _vm.blogLink,
      "wide": _vm.isPhoneOrTablet,
      "fill": false,
      "factor": 1.3
    }
  }, [_vm._v("Все записи")])], 1), _c('div', {
    staticClass: "article-buttons-col"
  }, [_c('ext-button', {
    attrs: {
      "size": "small",
      "color": _vm.nextBtnColor,
      "to": _vm.nextId,
      "wide": _vm.isPhoneOrTablet,
      "fill": true,
      "factor": 1.3,
      "disabled": _vm.hasNextDisabled
    }
  }, [_vm._v("Следующая запись")])], 1)])], 1), _c('blog-aside', _vm._l((_vm.articles), function(item) {
    return _c('blog-article-item', _vm._b({
      key: item.id,
      staticClass: "mb-4"
    }, 'blog-article-item', item, false))
  }), 1)], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ff8e25e","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/page/blog/article/Arcitle.vue
// module id = baab23ccf4bb7dd26f5d
// module chunks = 17